import template from './template.html';
import './styles.css';

controller.$inject = ['$scope', 'StoresService', 'UserService'];

export function controller($scope, StoresService, UserService) {
    const vm = this;

    vm.data = [];

    StoresService.getStores().then(stores => vm.data = stores);

    vm.setSortOrder = setSortOrder;
    vm.isSortedBy = isSortedBy;
    vm.userCanAddStores = false;
    
    vm.sort = StoresService.storesListState.sortOrder; 
    vm.searchCriteria = StoresService.storesListState.searchCriteria; 
    
    $scope.$watch('vm.sort', (sortOrder) => {
        StoresService.storesListState.sortOrder = sortOrder;
    });

    $scope.$watch('vm.searchCriteria', (searchCriteria) => {
        StoresService.storesListState.searchCriteria = searchCriteria;
    });

    init();
    
    function init() {
        UserService.isInRole('AddStore').then(result => vm.userCanAddStores = result);
    }

    function setSortOrder(propertyName) {
        vm.sort = vm.sort === propertyName ? '-' + propertyName : propertyName;
    }

    function isSortedBy(propertyName, direction) {
        if (vm.sort.indexOf(propertyName) >= 0) {
            if (direction == 'desc' && vm.sort.substring(0, 1) == '-') {
                return true;
            }
            if (direction == 'asc' && vm.sort.substring(0, 1) != '-') {
                return true;
            }
        }
        return false;
    }

}

config.$inject = ['$stateProvider'];

export function config($stateProvider) {
    $stateProvider.state('stores', {
        controller: controller,
        controllerAs: 'vm',
        parent: 'authorised',
        template: template,
        url: '^/stores'
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/authorised/storelist/index.js